import React from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AuthDebugger from './AuthDebugger';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <>
      <Navbar bg="dark" variant="dark" expand="lg">
        <Container>
          <Navbar.Brand as={Link} to="/dashboard">
            Sistema de Facturación
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link as={Link} to="/dashboard">Dashboard</Nav.Link>
              <Nav.Link as={Link} to="/clients">Clientes</Nav.Link>
              <Nav.Link as={Link} to="/products">Productos</Nav.Link>
              <Nav.Link as={Link} to="/quotes">Presupuestos</Nav.Link>
              <Nav.Link as={Link} to="/invoices">Facturas</Nav.Link>
              <Nav.Link as={Link} to="/config">Configuración</Nav.Link>
            </Nav>
            <Nav>
              <Navbar.Text className="me-3">
                Bienvenido, {user?.username}
              </Navbar.Text>
              <Button variant="outline-light" onClick={handleLogout}>
                Cerrar Sesión
              </Button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <main>{children}</main>
    
    </>
  );
};

export default Layout;